export enum ScimEntityType {
    User = 1,
    Group = 2,
}